import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useMemo } from 'react';

import { config } from '../env';
import { ANONYMOUS_IDENTITY, readIdentity, type ClmIdentity } from './claims';

/**
 * The signed-in user's claims, for display and for usability affordances only.
 * See claims.ts and permissions.ts — never a security boundary (NFR-06).
 */
export function useIdentity(): { identity: ClmIdentity; isAuthenticated: boolean } {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const identity = useMemo<ClmIdentity>(() => {
    if (!isAuthenticated) return ANONYMOUS_IDENTITY;
    return readIdentity(instance.getActiveAccount() ?? accounts[0] ?? null, config.role_groups);
    // `accounts` is the value that changes when MSAL settles a login, so it is
    // the dependency that matters even though getActiveAccount() is what reads.
  }, [instance, accounts, isAuthenticated]);

  return { identity, isAuthenticated };
}
